/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status__AuthorizedInputs */

const en_payment_status__authorized = /** @type {(inputs: Payment_Status__AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Payment_Status__AuthorizedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const payment_status__authorized = /** @type {((inputs?: Payment_Status__AuthorizedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status__AuthorizedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_payment_status__authorized(inputs)
});